import { combineReducers } from "redux";
import { appGamesSlice } from "../modules/appGames/redux/AppGamesSlice";
import { masterLayoutSlice } from "../modules/common/redux/MasterLayoutSlice";
import { dashboardSlice } from "../modules/dashboard/redux/DashboardSlice";
import { downloadSlice } from "../modules/download/redux/DownloadSlice";
import { fishingSlice } from "../modules/fishing/redux/FishingSlice";
import { gamePlaySlice } from "../modules/gamePlay/redux/GamePlaySlice";
import { homeSlice } from "../modules/home/redux/HomeSlice";
import { landingPageSlice } from "../modules/landingPage/redux/LandingPageSlice";
import { liveCasinoSlice } from "../modules/liveCasino/redux/LiveCasinoSlice";
import { lotterySlice } from "../modules/lottery/redux/LotterySlice";
import { promotionSlice } from "../modules/promotion/redux/PromotionSlice";
import { reportSlice } from "../modules/report/redux/ReportSlice";
import { settingSlice } from "../modules/setting/redux/SettingSlice";
import { slotSlice } from "../modules/slot/redux/SlotSlice";
import { sportSlice } from "../modules/sport/redux/SportSlice";

export const rootReducer = combineReducers({
  // get from slice file
  masterLayout: masterLayoutSlice.reducer,
  home: homeSlice.reducer,
  setting: settingSlice.reducer,
  slot: slotSlice.reducer,
  liveCasino: liveCasinoSlice.reducer,
  fishing: fishingSlice.reducer,
  promotion: promotionSlice.reducer,
  lottery: lotterySlice.reducer,
  appGames: appGamesSlice.reducer,
  gamePlay: gamePlaySlice.reducer,
  sport: sportSlice.reducer,
  download: downloadSlice.reducer,
  report: reportSlice.reducer,
  dashboard: dashboardSlice.reducer,
  landingPage: landingPageSlice.reducer,
  // mm6mmHome: persistReducer(
  //   { key: "mm6mmHome", storage, whitelist: ["mm6mmHomePageUI"] },
  //   mm6mmHomeSlice.reducer
  // ),
});
